<!--
The "value" property is expected to be an object that contain the following fields:

mode     - start, end, date
selected - Moment.range
-->

<template>
  <div class="calendar-dropdown">
    <div class="calendar-dropdown__label">Wybierz termin wyjazdu</div>
    <div class="calendar-dropdown__sublabel">Data powrotu będzie zależeć od wybranego czasu pobytu</div>

    <Calendar ref="calendar"
      :mode="value.mode"
      :selectedDates="value.selected"
      :validDates="validDates"
      :clearedDate="clearedDate"
      @close="close"
      @selectionModeChanged="setSelectionMode"
      @selectFrom="selectDateStart" @selectTo="selectDateEnd"
      @hoverFrom="highlightDateStart" @hoverTo="highlightDateEnd"
      @selectDate="selectDate" @selectMonth="selectMonth"
      @hoverDay="highlightDate" @hoverMonth="highlightMonth" />

    <div class="calendar-dropdown__footer" :class="{'calendar-main__tight': value.mode == 'month' && sameSeason }">
      <div @click="clear" class="calendar-dropdown__footer--clear"><Icon icon="cross" />Wyczyść</div>
      <span @click="close" class="calendar-dropdown__footer--select">Wybierz <Icon icon="v-right" /></span>
    </div>

    <div class="calendar-dropdown__close">
      <span class="custom-icon--cross calendar-header__icon" @click="close" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { DateRange } from 'moment-range'
import Vue from 'vue'
import Component from 'vue-class-component'

import AutoCloseMixin from '@/components/AutoCloseMixin'
import Calendar from '@/components/Calendar.vue'
import Icon from '@/components/Icon.vue'

@Component({
  mixins: [
    AutoCloseMixin,
  ],
  components: {
    Calendar,
    Icon,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    validDates: {
      type: DateRange,
      required: false,
      default: () => moment.range(0, 9999999),
    },
  },
  watch: {
    'value.mode': {
      handler (newValue) {
        // This is not nice but necessary because the Calendar has internal
        // state that is not directly taken from the given props
        this.$refs.calendar.selectionMode = newValue
      },
    },
  },
})
export default class CalendarDropdown extends Vue {
  clearedDate = this.validDates
  highlighted = moment.range(this.value.selected.start, this.value.selected.end)
  sameSeason = moment(this.value.selected.start).isSame(this.value.selected.end, 'year')

  mounted () {
    this.$emit('adjustVisibility', this.$el)
  }

  setCalendarMode (mode) {
    this.$refs.calendar.selectionMode = mode
  }

  update () {
    this.$emit('updateEditedDates', this.highlighted.start, this.highlighted.end)
  }

  setSelectionMode (mode) {
    this.value.mode = mode
  }

  selectDateStart (day) {
    this.value.selected.start = day
    this.value.mode = 'end'
  }

  selectDateEnd (day) {
    this.value.selected.end = day
    this.value.mode = 'start'
  }

  selectDate (day) {
    this.value.selected.start = day
    this.value.mode = 'date'
  }

  selectMonth (start, end) {
    this.value.selected.start = start
    this.value.selected.end = end
  }

  highlightDateStart (day) {
    this.highlighted.start = day
    this.update()
  }

  highlightDateEnd (day) {
    this.highlighted.end = day
    this.update()
  }

  highlightDate (day) {
    this.highlighted.start = day
    this.update()
  }

  highlightMonth (start, end) {
    this.highlighted.start = start
    this.highlighted.end = end
    this.update()
  }

  clear () {
    this.value.selected.start = this.validDates.start
    this.value.selected.end = this.validDates.end
    this.highlighted = moment.range(this.validDates.start, this.validDates.end)
    this.clearedDate = moment.range(this.validDates.start, this.validDates.end)
    this.update()

    if (this.value.mode === 'month') {
      this.value.mode = 'start'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../dialog';

.calendar-dropdown {
  @include dialog();
  padding: 20px;

  &__label {
    color: #005ca9;
    font-size: 17px;
    line-height: 1;
    font-weight: bold;
  }

  &__sublabel {
    color: #005ca9;
    margin: 6px 0 14px;
  }

  &__close {
    position: absolute;
    right: 0;
    padding: 0 7px;
    top: -3px;
    color: #005ca9;
    cursor: pointer;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    text-transform: uppercase;
    margin-top: 6px;

    .figure--v-right {
      display: flex;
    }

    &--select {
      display: flex;
      align-items: flex-end;
      border: 2px solid #005CA9;
      color: #005CA9;
      background-color: transparent;
      font-weight: bold;
      font-size: 12px;
      padding: 7px 18px;
      font-family: 'Gotham';
      cursor: pointer;
      transition: .05s all ease-in-out;

      &:hover {
        background-color: #009FEA;
        border-color: #009FEA;
        color: #fff;
      }

      .figure {
        font-size: 16px;
        line-height: 7px;
      }
    }

    &--clear {
      text-transform: uppercase;
      font-size: 12px;
      margin-right: 20px;
      cursor: pointer;
      line-height: 1;
      padding: 8px 0;
      display: flex;

      &:hover {
        color: #009FEA;
      }

      .figure {
        font-size: 8px;
        line-height: 12px;
        margin-right: 6px;
      }
    }
  }
}

.calendar-main__tight {
  padding: 0 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/CalendarDropdown.vue